module.exports = __webpack_public_path__ + "img/CY110008.71ac833a.png";